module.exports = __webpack_public_path__ + "img/lang.4f41d440.svg";